define(["require", "exports", "tslib", "@material-ui/core/List", "@material-ui/core/ListItem", "@material-ui/core/ListItemIcon", "@material-ui/core/ListItemText", "@material-ui/core/colors/blue", "@material-ui/icons/Error", "@material-ui/icons/Info", "@material-ui/icons/Warning", "mobx-react", "react", "../model/EntityValidationState", "../model/services/EventManager", "../store/Events", "../utils/ColourUtil", "./blocks"], function (require, exports, tslib_1, List_1, ListItem_1, ListItemIcon_1, ListItemText_1, blue_1, Error_1, Info_1, Warning_1, mobx_react_1, React, EntityValidationState_1, EventManager_1, Events_1, ColourUtil_1, blocks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValidationView = void 0;
    List_1 = tslib_1.__importDefault(List_1);
    ListItem_1 = tslib_1.__importDefault(ListItem_1);
    ListItemIcon_1 = tslib_1.__importDefault(ListItemIcon_1);
    ListItemText_1 = tslib_1.__importDefault(ListItemText_1);
    blue_1 = tslib_1.__importDefault(blue_1);
    Error_1 = tslib_1.__importDefault(Error_1);
    Info_1 = tslib_1.__importDefault(Info_1);
    Warning_1 = tslib_1.__importDefault(Warning_1);
    React = tslib_1.__importStar(React);
    const style = {
        validationContainer: {
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "visible",
            zIndex: 10000
        },
        validationText: {
            textOverflow: "clip",
            wordWrap: "break-word"
        }
    };
    let ValidationView = exports.ValidationView = class ValidationView extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                validation: null
            };
        }
        componentDidMount() {
            EventManager_1.EventManager.Instance.on(Events_1.VALIDATION_UPDATE_EVENT, (validation) => {
                this.setState({
                    validation
                });
            });
            EventManager_1.EventManager.Instance.on("validation.clear", () => {
                this.setState({
                    validation: null
                });
            });
        }
        resetValidation() {
            EventManager_1.EventManager.Instance.emit("validation.clear");
        }
        render() {
            const validation = this.state.validation;
            let validationView = null;
            if (!!validation && validation.HasMessages) {
                let validationHeader = "Save Succeeded with messages";
                let validationDescription = "";
                let validationColor = "#8EB4E3";
                if (validation.HasErrors) {
                    validationHeader = "Validation Failed";
                    validationDescription =
                        "The application contains errors and therefore was not saved. Please correct the validation errors and then re-save.";
                    validationColor = "#ff1493";
                }
                else if (validation.HasWarnings) {
                    validationHeader = "Save Succeeded with warnings";
                    validationDescription =
                        "The application was saved however the following issues were observed. If neccessary, you can correct the issues and then re-save.";
                    validationColor = "#FFCC33";
                }
                const error = React.createElement(Error_1.default, { htmlColor: "#ff1493" });
                const warning = React.createElement(Warning_1.default, { htmlColor: "#FFCC33" });
                const info = React.createElement(Info_1.default, { htmlColor: blue_1.default[50] });
                validationView = (React.createElement("div", { style: style.validationContainer, className: "animated fadeIn" },
                    React.createElement(blocks_1.Header, { title: validationHeader, style: { background: "inherit", backgroundColor: validationColor } },
                        React.createElement(blocks_1.HeaderButton, { label: "Ok", backgroundColor: ColourUtil_1.ColourUtil.shadeColorHex(validationColor, 0.2), hoverColor: ColourUtil_1.ColourUtil.shadeColorHex(validationColor, -0.1), onClick: this.resetValidation.bind(this) })),
                    React.createElement(blocks_1.VGroup, { className: "form" },
                        React.createElement("div", { style: style.validationText }, validationDescription),
                        React.createElement(List_1.default, null, validation.flatten().map((m, index) => {
                            return (React.createElement(ListItem_1.default, { key: index },
                                React.createElement(ListItemIcon_1.default, null, m.Type === EntityValidationState_1.MessageType.Error
                                    ? error
                                    : m.Type === EntityValidationState_1.MessageType.Warning
                                        ? warning
                                        : info),
                                React.createElement(ListItemText_1.default, { primary: m.Msg, secondary: m.Alias, style: { whiteSpace: "pre-line" } })));
                        })))));
            }
            return validationView;
        }
    };
    exports.ValidationView = ValidationView = tslib_1.__decorate([
        mobx_react_1.observer
    ], ValidationView);
});
